import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row, Button, Spinner } from 'reactstrap';

import { ToastContainer, toast } from 'react-toastify';
import { fetchProducts } from '../../utils/products';
import { API_BASE_URL } from '../../config';
import BreadCrumb from "../../Components/Common/BreadCrumb";
import productPlaceholder from "../../assets/images/products/img-1.png"; // Placeholder image

import  ZendeskWidget  from "../../Components/CustomerSupport/ZendeskWidget";

const List = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  
    const user = JSON.parse(sessionStorage.getItem("user")); 
    const role = user.role;
    useEffect(() => {
        
        const loadProductsData = async () => {
            setLoading(true);
            try {
                const company_id =user.company_id; 
            
                const param={
                    page: currentPage,
                    per_page: 8,
                    company_id:company_id?company_id:null, 
                }
                const response = await fetchProducts(param);
                console.log(response); 
                
                // Handle null response (API error)
                if (!response) {
                    errornotify("Failed to load products. Please try again.");
                    setProducts([]);
                    return;
                }
                
                if (response.status==200) {
                    setProducts(response.data.products || []);
                    setTotalPages(response.data.pages || 1);
                    setCurrentPage(response.data.current_page || 1); 
                }else {
                    errornotify(response.data?.message || "Failed to load products")  
                    setProducts([]);
                }
            } catch (error) {
                console.error("Error loading products:", error);
                errornotify(error.message || "Failed to load products") 
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        loadProductsData();
    }, [currentPage]);

    // useEffect(() => {
    //     window.zE && window.zE('webWidget', 'hide');
        
    //     // Show after 3 seconds
    //     setTimeout(() => {
    //       window.zE && window.zE('webWidget', 'show');
    //     }, 3000);
    //   }, []);
      

    if (loading) {
        return <div className="text-center mt-5"><Spinner /> Loading products...</div>;
    }

    return (
        
        <div className="page-content">
             <ZendeskWidget />
             <BreadCrumb title="Product List"  />
            <Row className="g-4">  
            <ToastContainer />
                <Col lg={12}> 
                    {role==="customer"?"":<div className="col-sm-auto  mb-3">
                        <div>
                            <Link to="/add-product" className="btn btn-soft-secondary"><i
                                className="ri-add-line align-bottom me-1"></i> Add New</Link>
                        </div>
                    </div> }
                    
                    <Row  className="row">
                        {products && products.length > 0 ? (
                            products.map((product) => (
                                <Col xl={3} md={4} sm={6} key={product.id}>
                                    <Card>
                                        <CardBody>
                                            <img 
                                                src={
                                                    product.editions && 
                                                    product.editions.length > 0 && 
                                                    product.editions[0].images && 
                                                    product.editions[0].images.length > 0
                                                        ? API_BASE_URL + "/file/product/image/" + product.editions[0].images[0].image_url
                                                        : productPlaceholder
                                                } 
                                                alt={product.name || "Product"} 
                                                className="img-fluid d-block mx-auto mb-3"
                                                style={{ maxHeight: "200px" }}
                                                onError={(e) => {
                                                    e.target.src = productPlaceholder;
                                                    e.target.onerror = null; // Prevent infinite loop
                                                }}
                                            />
                                            <h5>{product.name || "N/A"}</h5>
                                            <p><strong>Brand:</strong> {product.brand || "N/A"}</p>
                                            <p><strong>Category ID:</strong> {product.category_id || "N/A"}</p>
                                            <p><strong>Short Description:</strong> {
                                                product.short_description && product.short_description.length > 20 
                                                    ? product.short_description.substring(0, 19) + "..." 
                                                    : product.short_description || "N/A"
                                            }</p>
                                            
                                            {/* Display Editions */}
                                            <h6>Available Editions:</h6>
                                            <ul>
                                                {product.editions && product.editions.length > 0 ? (
                                                    product.editions.map((edition) => (
                                                        <li key={edition.id}>
                                                            {edition.edition_name || "Unnamed Edition"} - ${edition.price || "0.00"}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li>No editions available</li>
                                                )}
                                            </ul>

                                            {/* Display Tags */}
                                            <h6>Tags:</h6>
                                            <p>{product.tags && product.tags.length > 0 ? product.tags.join(", ") : "No tags available"}</p>

                                            <Link color="success"   className="btn btn-success w-100"  to={"/product-detail?productId="+product.id}   >
                                                View Details
                                            </Link>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col lg={12}>
                                <div className="text-center mt-5">
                                    <h4>{!products ? "Loading products..." : "No products found."}</h4>
                                </div>
                            </Col>
                        )}
                    </Row>

                    {/* Pagination */}
                    <Row className="mt-4">
                        <Col sm={12} className="text-center">
                            <Button 
                                disabled={currentPage === 1} 
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                Previous
                            </Button>
                            <span className="mx-3">
                                Page {currentPage} of {totalPages}
                            </span>
                            <Button 
                                disabled={currentPage === totalPages} 
                                onClick={() => setCurrentPage(currentPage + 1)}
                            >
                                Next
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default List;
